import React from 'react';
import classNames from 'classnames';

interface IRadioProps<T> {
    options: T[];
    selected?: T | ((option: T) => boolean);
    getLabel: (option: T, checked: boolean, disabled: boolean) => React.ReactElement;
    disabled?: T[] | ((option: T) => boolean)
    onChange: (option: T) => void;
    name: string;
    rootClassName?: string;
    buttonClassName?: string;
    inputClassName?: string;
    labelClassName?: string;
}

const Radio = <T,>({ options, selected, getLabel, onChange, rootClassName, buttonClassName, inputClassName, labelClassName, disabled, name }: IRadioProps<T>) =>
    <div role='group' className={classNames('radio__button', rootClassName)} >
        {options.map((option) => {
            const key = JSON.stringify(option);
            const checked = selected instanceof Function
                ? selected(option)
                : option === selected;
            const isDisabled = disabled instanceof Function
                ? disabled(option)
                : !!disabled?.includes(option);
            return (
                <div key={key} className={classNames('radio__button', buttonClassName)}>
                    <input
                        checked={checked}
                        className={classNames('radio__input', inputClassName)}
                        name={name}
                        type='radio'
                        id={key}
                        disabled={isDisabled}
                        onChange={() => onChange(option)}
                    />
                    <label className={classNames('radio__label', labelClassName)} htmlFor={key} >
                        {getLabel(option, checked, isDisabled)}
                    </label>
                </div>
            )
        })}
    </div>

export default Radio;